import { render } from "./firstscreenSection.vue?vue&type=template&id=0a003272"
import script from "./firstscreenSection.vue?vue&type=script&lang=js"
export * from "./firstscreenSection.vue?vue&type=script&lang=js"

import "./firstscreenSection.vue?vue&type=style&index=0&id=0a003272&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__